import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloat = () => {
  const phoneNumber = '919448145300'; // Replace with your actual WhatsApp number
  const message = 'Hello! I have a question about your services.';
  
  const handleClick = (e) => {
    // Prevent default to avoid showing the URL in the status bar
    e.preventDefault();
    // Open WhatsApp in a new tab
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const whatsappUrl = ''; // Using # as a fallback

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 group">
      <div className="flex items-center gap-1 sm:gap-2">
        <span className="hidden md:flex opacity-0 group-hover:opacity-100 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-xs sm:text-sm font-semibold px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-xl transition-all duration-500 transform group-hover:translate-x-0 translate-x-2 whitespace-nowrap items-center gap-1.5 sm:gap-2">
          <span className="animate-pulse"></span>
          Let's Power Up Your Machines!
          <span className="animate-bounce">⚡</span>
        </span>
        <a
          href={whatsappUrl}
          onClick={handleClick}
          className="relative bg-gradient-to-br from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-full p-2.5 sm:p-4 shadow-xl flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 hover:rotate-12 cursor-pointer group/icon hover:shadow-2xl hover:shadow-green-500/30 text-xl sm:text-2xl"
          aria-label="Chat on WhatsApp"
          
        >
          <div className="absolute inset-0 bg-white/10 rounded-full animate-ping opacity-0 group-hover/icon:opacity-100 transition-opacity duration-1000"></div>
          <FaWhatsapp className="w-8 h-8 relative z-10 transform group-hover/icon:scale-110 transition-transform" />
          <div className="absolute -inset-1 bg-gradient-to-r from-green-400 to-emerald-600 rounded-full -z-10 opacity-70 blur-md group-hover/icon:opacity-100 group-hover/icon:blur-lg transition-all duration-300"></div>
        </a>
      </div>
    </div>
  );
};

export default WhatsAppFloat;


// 💬 Professional & Friendly

// Let’s Talk Hydraulics! 💬

// Chat with Our Experts ⚙️

// We’re Just a Ping Away 📲

// Instant Support on WhatsApp 🚀

// Get Quick Assistance 💡

// 🌟 Impressive & Engaging

// Let’s Power Up Your Machines! ⚡

// Your Hydraulic Partner Awaits 💪

// Tap to Connect Instantly 🔧

// Expert Help in Seconds ⚙️

// Revive Your Equipment with Us 🔩

// 💼 Corporate & Trust-Building

// Connect with Hospet Hydraulics 🤝

// Trusted Support, One Click Away 💬

// We Value Your Queries 🔧

// Talk to Our Service Team 📞

// Let’s Keep Your System Running Smoothly 🔩